import gql from 'graphql-tag';

export const getEventEvidenceListQuery = gql`
  query allEventEvidences(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: EventEvidenceFilter
  ) {
    items: allEventEvidences(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      id
      eventId
      evidenceId {
        id
        name
        uploadChoice
      }
      pdf {
        url
      }
      content
      name
      folderNumber
      orderIndex
      requiredActors
      createdAt
      updatedAt
      deletedAt
      __typename
    }
    total: _allEventEvidencesMeta(
      page: $page
      perPage: $perPage
      filter: $filter
    ) {
      count
    }
  }
`;
